import { render, staticRenderFns } from "./CertificateSettings.vue?vue&type=template&id=49441a33&scoped=true"
import script from "./CertificateSettings.vue?vue&type=script&lang=js"
export * from "./CertificateSettings.vue?vue&type=script&lang=js"
import style0 from "./CertificateSettings.vue?vue&type=style&index=0&id=49441a33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49441a33",
  null
  
)

export default component.exports